/* eslint-disable camelcase */
/* eslint-disable no-param-reassign */
import React, { useContext, Suspense } from 'react';
import { AuthContext } from '@xometry/auth-context';
import { Spinner } from '@xometry/xometry_loft';
import {
  WORKCENTER_ORIGIN,
  WWW_ORIGIN,
  API_ORIGIN,
  WORK_ORIGIN,
  PART_FILE_ORIGIN,
  RFQ_ORIGIN,
} from '../../config';
import history from '../../history';
import { lazyWithRetries } from '../../utils/shimport';

const COMPONENT_URL = `${WWW_ORIGIN}/components/rfq-response-component/index.js`;
const RfqResponseMfe = lazyWithRetries(COMPONENT_URL);

const SupplierAccount = () => {
  const { isLoading, user } = useContext(AuthContext);

  if (isLoading) {
    return <Spinner />;
  }

  if (!user) {
    window.location.assign('/login');
  }

  const config = {
    user: {
      id: user.id,
      _id: user.id,
      firstName: user.firstName,
      lastName: user.lastName,
    },
    origins: {
      xometry: {
        api: API_ORIGIN,
        partFiles: PART_FILE_ORIGIN,
        rfq: RFQ_ORIGIN,
        work: WORK_ORIGIN,
        www: WWW_ORIGIN,
        workcenter: WORKCENTER_ORIGIN,
      },
    },
  };

  // TODO
  // Make RfeResponseMfe not depend on variables on window
  // @ts-expect-error property on window
  window.XGLOBALS = {
    personalizationRoot: WWW_ORIGIN,
  };

  return (
    <Suspense fallback={<Spinner />}>
      <RfqResponseMfe config={config} history={history} />
    </Suspense>
  );
};

export default SupplierAccount;
